import React, { Component } from 'react';
import Calendar from '../../../common/calendar/Calender';
import onClickOutside from 'react-click-outside';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import './priceDataDate.scss';
import TimeRangeWrapper from '../../../common/time-range-wrapper';

class PriceDataDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkShowCalendar: false,
    };
  }

  handleClickOutside = evt => {
    if (this.state.checkShowCalendar) {
      this.setState({
        ...this.state,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        checkShowCalendar: false,
      });
    }
  };

  showCalendar = e => {
    const checkShowCalendar = !this.state.checkShowCalendar;
    this.setState({ ...this.state, checkShowCalendar });
  };

  handleDateApply = (startDate, endDate) => {
    const itemDate = {
      startDate:
        startDate !== '' && startDate !== null
          ? moment(startDate).format('MM/DD/YYYY')
          : null,
      endDate:
        endDate !== '' && endDate !== null
          ? moment(endDate).format('MM/DD/YYYY')
          : null,
    };
    this.props.handleDateChange(itemDate);
    const checkShowCalendar = !this.state.checkShowCalendar;
    this.setState({
      checkShowCalendar,
      startDate: startDate !== null ? startDate : '',
      endDate: endDate !== null ? endDate : '',
    });
  };

  resetDate = () => {
    const { startDate, endDate, handleDateChange } = this.props;
    if (!startDate && !endDate) return;
    const itemDate = {
      startDate: null,
      endDate: null,
    };
    this.setState(
      {
        startDate: null,
        endDate: null,
      },
      () => handleDateChange(itemDate),
    );
  };

  render() {
    const { startDate, endDate, nameFrom } = this.props;
    let to = I18n.t('common.lstLabelCalendar.to');
    return (
      <TimeRangeWrapper onClickCloseButton={() => this.resetDate()}>
        <div className="price-data-date-custom-price-data">
          <div className="price-data-date">
            <div className="parent">
              <div className="wide ml-10 position-relative">
                <label className=" d-flex align-items-center justify-content-center">
                  {nameFrom}
                </label>
                <div>
                  <a
                    className="narrow"
                    onClick={this.showCalendar}
                    ref={c => (this.buttonCalendar = c)}
                  >
                    {startDate}
                    <span className="place-date">
                      <i className="icon-caret" />
                    </span>
                  </a>
                  {this.state.checkShowCalendar && (
                    <Calendar
                      parentRef={this.buttonCalendar}
                      startDate={
                        startDate !== null
                          ? moment(new Date(startDate))
                          : this.state.startDate
                      }
                      endDate={
                        endDate !== null
                          ? moment(new Date(endDate))
                          : this.state.endDate
                      }
                      handleDateApply={this.handleDateApply}
                    />
                  )}
                </div>
              </div>
              <div className="wide-to">
                <label
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: '20px' }}
                >
                  {to}
                </label>
                <div className="narrow-to" onClick={this.showCalendar}>
                  {endDate}
                  <span className="place-date">
                    <i className="icon-caret" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TimeRangeWrapper>
    );
  }
}

export default onClickOutside(PriceDataDate);
